import classNames from 'clsx';
import InputAdornment from '@material-ui/core/InputAdornment';
import Sort from '@material-ui/icons/Sort';
import Fade from '@material-ui/core/Fade';

import { SortAdornmentProps } from './SortAdornment.interface';
import { useStyles } from './SortAdornment.styles';

export default function SortAdornment({ className }: SortAdornmentProps) {
  const classes = useStyles();

  return (
    <Fade in>
      <InputAdornment
        disablePointerEvents
        position="start"
        className={classNames(classes.root, className)}
      >
        <Sort />
      </InputAdornment>
    </Fade>
  );
}
